import { render, staticRenderFns } from "./customer_inquiry_detail.vue?vue&type=template&id=5228dcca&scoped=true"
import script from "./customer_inquiry_detail.vue?vue&type=script&lang=js"
export * from "./customer_inquiry_detail.vue?vue&type=script&lang=js"
import style0 from "./customer_inquiry_detail.vue?vue&type=style&index=0&id=5228dcca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228dcca",
  null
  
)

export default component.exports